export default __webpack_public_path__ + "static/media/centricLandingBackground.4201f453.png";